import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BridgeColumn = ({ label, amount, offset, height, isPlaceholder, isDeduction, isNegative }) => {
  const theme = useTheme()
  const isLoss = isDeduction || isNegative
  const amountColor = isLoss ? theme.palette.red.tone800 : theme.colors.text.default

  return (
    <Styles.Container>
      <Styles.Track>
        <Styles.Plot>
          {isPlaceholder && (
            <Styles.Placeholder>
              <Text type="bodySMedium" color={theme.colors.text.muted}>
                {amount}
              </Text>
            </Styles.Placeholder>
          )}
          {!isPlaceholder && isDeduction && (
            <Styles.Reference data-testid="bridge-reference" barOffset={offset} barHeight={height} />
          )}
          {!isPlaceholder && (
            <Styles.Bar
              role="img"
              aria-label={`${label}: ${amount}`}
              barOffset={offset}
              barHeight={height}
              isLoss={isLoss}
            >
              <Styles.Amount>
                <Text type="bodySMedium" color={amountColor}>
                  {amount}
                </Text>
              </Styles.Amount>
            </Styles.Bar>
          )}
        </Styles.Plot>
      </Styles.Track>
      <Styles.Label>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {label}
        </Text>
      </Styles.Label>
    </Styles.Container>
  )
}

export default BridgeColumn
